import * as Yup from "yup";
import dayjs from "dayjs";
import { msg } from "../../vehicleFormErrors";

/*
 * Messages are i18n KEYS (see vehicleFormErrors.ts), translated where they
 * are displayed.
 *
 * VIN is deliberately OPTIONAL here. It is required at creation, but a vehicle
 * can reach the fleet without one (mobile creation, legacy rows), and the VIN
 * field used to be read-only AND required: such a vehicle could never be saved
 * again, whatever the user completed - one of the dead ends behind the STC
 * incident. The field is now editable when empty, and an empty VIN no longer
 * blocks completing the rest of the record.
 */
export const validationSchemaUpdateVehicle = Yup.object().shape({
  vin: Yup.string().nullable(),
  immatriculation: Yup.string().trim().required(msg("required")),
  brand: Yup.object()
    .nullable()
    .test("brand-picked", msg("brandFromList"), (value: any) => !!value?.id),
  modele: Yup.object()
    .nullable()
    .test("model-picked", msg("modelFromList"), (value: any) => !!value?.id),
  gearBox: Yup.string().nullable().required(msg("required")),
  fiscalPower: Yup.string().trim().nullable().required(msg("required")),
  energy: Yup.string().nullable().required(msg("required")),
  // Labelled "*" and required by the old checkValues(): kept required, but it
  // now SAYS so instead of failing silently.
  releaseDate: Yup.string()
    .nullable()
    .required(msg("required"))
    .test("valid-date", msg("dateInvalid"), (value) =>
      !value ? true : dayjs(value).isValid()
    ),
  status: Yup.string().nullable().required(msg("required")),
});

export interface FormValuesVehicleUpdate {
  vin: string | null;
  immatriculation: string | null;
  brand: { id?: number | null; name?: string | null } | null;
  modele: { id?: number | null; name?: string | null } | null;
  gearBox: string | null;
  fiscalPower: string | null;
  energy: string | null;
  /** "YYYY-MM-DD", or "" when unknown. */
  releaseDate: string | null;
  status: string | null;
}

export const initialValuesVehicleUpdate = {
  vin: null,
  immatriculation: null,
  brand: null,
  modele: null,
  gearBox: null,
  fiscalPower: null,
  energy: null,
  releaseDate: null,
  status: null,
} as FormValuesVehicleUpdate;
